export default "__VITE_ASSET__e4b77eb3__"